module.exports = __webpack_public_path__ + "static/media/introduce.ce2cc990.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程E200S平板车/introduce.png
// module id = 725
// module chunks = 0